import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);
const latestNews = articles.filter((a) => a.category === 'news').slice(0, 3);
const latestWorks = articles.filter((a) => a.category === 'works').slice(0, 3);
const latestPhotos = articles.filter((a) => a.category === 'photos').slice(0, 3);

const profileData = {
  name: '朝桐光',
  nameEn: 'Asahi Karu',
  birthday: '1995年3月15日',
  birthplace: '日本东京都',
  height: '163cm',
  bloodType: 'A型',
  hobby: '钢琴、茶道、摄影',
  debut: '2013年（偶像团体出道）',
  agency: 'Stardust Promotion',
  bio: '朝桐光，日本知名女演员、模特。2013年以偶像团体成员身份出道，2018年开始专注于演员事业。凭借在《东京夜曲》中的出色表演获得第36届横滨电影节最佳女演员奖，随后在《京都恋歌》等作品中持续展现出精湛的演技与独特的个人魅力，是日本演艺圈最具代表性的实力派女演员之一。',
};

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '朝桐光官方粉丝资讯站',
            url: 'https://plushy.cn',
            description: '朝桐光官方粉丝资讯与作品全览，汇聚最新资讯、作品介绍、个人档案及粉丝社区。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://plushy.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: '朝桐光',
            alternateName: 'Asahi Karu',
            birthDate: '1995-03-15',
            birthPlace: { '@type': 'Place', name: '日本东京都' },
            nationality: '日本',
            knowsAbout: ['演艺', '电影', '电视剧', '模特'],
            description: '朝桐光，日本知名女演员、模特，凭借《东京夜曲》获得横滨电影节最佳女演员奖。',
          }),
        }}
      />

      <HeroSection />
      <FeaturedSection />
      <LatestContent />
      <ProfileSection />
      <CommunityCTA />
    </>
  );
}

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20actress%20artistic%20silhouette%20in%20soft%20golden%20sunset%20light%2C%20minimalist%20composition%2C%20dreamy%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20cinematic%20portrait%20photography%20with%20shallow%20depth%20of%20field%2C%20bokeh%20background%2C%20graceful%20elegant%20style&width=1600&height=800&seq=asa-hero-bg&orientation=landscape"
        alt="朝桐光"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="朝桐光 - 官方粉丝资讯站"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
        <p className="text-white/80 text-xs md:text-sm font-sans tracking-[0.3em] mb-3 md:mb-4 uppercase">
          OFFICIAL FAN SITE
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 tracking-wider">
          朝桐光
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-xl leading-relaxed">
          汇聚最新资讯、作品介绍、个人档案与粉丝社区<br className="hidden sm:block" />
          帮助喜爱朝桐光的粉丝第一时间掌握全面动态
        </p>
        <div className="flex items-center gap-3 mt-6 md:mt-8">
          <Link
            to="/category/news"
            className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-sans hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览资讯
          </Link>
          <Link
            to="/about"
            className="px-5 py-2.5 bg-white/15 text-white border border-white/30 rounded-full text-sm font-sans hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

function FeaturedSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prev = () => setCurrentIndex((i) => (i === 0 ? featuredArticles.length - 1 : i - 1));
  const next = () => setCurrentIndex((i) => (i === featuredArticles.length - 1 ? 0 : i + 1));

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选不容错过的热门内容</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={prev}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="Previous"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={next}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="Next"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>

        <div className="md:hidden relative overflow-hidden rounded-lg">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {featuredArticles.map((article) => (
              <div key={article.id} className="w-full flex-shrink-0">
                <ArticleCard article={article} variant="featured" />
              </div>
            ))}
          </div>
          <div className="flex items-center justify-center gap-1.5 mt-4">
            {featuredArticles.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                  i === currentIndex ? 'bg-primary-500' : 'bg-background-300'
                }`}
                aria-label={`Slide ${i + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function LatestContent() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <ContentColumn
            title="最新资讯"
            icon="ri-newspaper-line"
            linkTo="/category/news"
            articles={latestNews}
          />
          <ContentColumn
            title="作品精选"
            icon="ri-movie-2-line"
            linkTo="/category/works"
            articles={latestWorks}
          />
          <ContentColumn
            title="写真图集"
            icon="ri-gallery-line"
            linkTo="/category/photos"
            articles={latestPhotos}
          />
        </div>
      </div>
    </section>
  );
}

function ContentColumn({
  title,
  icon,
  linkTo,
  articles: columnArticles,
}: {
  title: string;
  icon: string;
  linkTo: string;
  articles: typeof latestNews;
}) {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className={`${icon} text-sm`}></i>
          </span>
          <h3 className="font-heading text-base font-semibold text-foreground-900">{title}</h3>
        </div>
        <Link
          to={linkTo}
          className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-0.5"
        >
          更多 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="flex flex-col gap-1">
        {columnArticles.map((article) => (
          <ArticleCard key={article.id} article={article} variant="compact" />
        ))}
      </div>
    </div>
  );
}

function ProfileSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          <div className="w-full lg:w-[380px] flex-shrink-0">
            <div className="aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20actress%20artistic%20portrait%2C%20minimalist%20studio%20photography%2C%20soft%20warm%20lighting%2C%20clean%20cream%20background%2C%20graceful%20pose%2C%20natural%20makeup%2C%20professional%20editorial%20style%2C%20serene%20expression&width=600&height=800&seq=asa-profile&orientation=portrait"
                alt="朝桐光个人写真"
                className="w-full h-full object-cover"
                title="朝桐光个人写真"
              />
            </div>
          </div>

          <div className="flex-1">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-1">
              个人档案
            </h2>
            <p className="text-sm text-foreground-500 mb-6">Profile of {profileData.nameEn}</p>

            <p className="text-sm text-foreground-700 leading-relaxed mb-6">{profileData.bio}</p>

            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
              <ProfileItem label="本名" value={profileData.name} />
              <ProfileItem label="英文名" value={profileData.nameEn} />
              <ProfileItem label="出生日期" value={profileData.birthday} />
              <ProfileItem label="出生地" value={profileData.birthplace} />
              <ProfileItem label="身高" value={profileData.height} />
              <ProfileItem label="血型" value={profileData.bloodType} />
              <ProfileItem label="爱好" value={profileData.hobby} />
              <ProfileItem label="出道" value={profileData.debut} />
              <ProfileItem label="经纪公司" value={profileData.agency} />
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 mt-6 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              了解更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function ProfileItem({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline gap-2">
      <span className="text-xs text-foreground-400 whitespace-nowrap">{label}</span>
      <span className="text-sm text-foreground-800">{value}</span>
    </div>
  );
}

function CommunityCTA() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-accent-100/50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
          加入粉丝社区
        </h2>
        <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto">
          与来自世界各地的朝桐光粉丝一起讨论作品、分享创作、参与活动。
          在这里，每一位粉丝的声音都被倾听和珍惜。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/community"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-sans hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            进入社区
          </Link>
          <a
            href="#"
            className="px-6 py-2.5 border border-foreground-300 text-foreground-700 rounded-full text-sm font-sans hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            关注微博
          </a>
        </div>
      </div>
    </section>
  );
}